const collator = new Intl.Collator("de", { numeric: true, sensitivity: "base" });

export const sortByPropertyNumber = (props) =>
  [...props].sort((a, b) => collator.compare(a.property_number || "~", b.property_number || "~") || collator.compare(a.name || "", b.name || ""));

export const propertyMatches = (p, q) => {
  const s = (q || "").trim().toLowerCase();
  if (!s) return true;
  return [p.name, p.property_number, addressText(p)].filter(Boolean).join(" ").toLowerCase().includes(s);
};

export const addressText = (p) => {
  const a = p.address || {};
  return [a.street, a.house_number, a.zip, a.city].filter(Boolean).join(" ");
};

export const comparePropertyNumber = (a, b) => collator.compare(a || "~", b || "~");
